import { ArrowDownLeft, ArrowUpRight } from 'lucide-react';
import { data, dinheiro, nomeParceiro, textoLivre } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';

/**
 * Lista de 30/10 (item 10): contas a receber (faturas) e a pagar na busca da barra superior, pelo número, descrição ou
 * parceiro (a busca da lista). A lista lê `?busca=`: o item abre a lista com o número (em todos os estados) e "Ver todos" com o
 * termo. Duas fontes, porque cada aba é uma página do papel.
 */
interface DocumentoBusca {
  id: string;
  numero: string;
  descricao: string;
  parceiro_nome: string | null;
  vencimento: string;
  saldo_centavos: number;
  valor_centavos: number;
  moeda: string;
}

const fonte = (chave: 'receber' | 'pagar'): FonteBuscaGlobal<DocumentoBusca> => {
  const aba = chave === 'receber' ? 'a-receber' : 'a-pagar';
  const lista = (busca: string) => `${caminhoDaAba('contas', aba)}?estado=todos&busca=${encodeURIComponent(busca)}`;
  return {
    chave,
    permissao: 'contas.ver',
    pagina: `contas.${aba}`,
    grupo: `buscaGlobal.${chave}`,
    posicao: chave === 'receber' ? 70 : 72,
    icone: chave === 'receber' ? ArrowDownLeft : ArrowUpRight,
    item: (d) => ({
      id: d.id,
      rotulo: `${d.numero} · ${nomeParceiro(d.parceiro_nome)}`,
      detalhe: [textoLivre(d.descricao, d.parceiro_nome), data(d.vencimento), dinheiro(d.valor_centavos, d.moeda)].filter(Boolean).join(' · '),
      link: lista(d.numero),
    }),
    verTodos: lista,
  };
};

export const buscaContas: FonteBuscaGlobal[] = [fonte('receber'), fonte('pagar')];
